import { Card, Grid, Skeleton } from '@mui/material';
import React from 'react';
import { ImageSkeletonProps } from './types';
const ImageSkeleton: React.FunctionComponent<ImageSkeletonProps> = (props) => {
  const { height } = props;
  const renderImageSkeleton = () => {
    return (
      <Grid item>
        <Card
          sx={{
            height: 150,
            width: 175,
          }}
        >
          <Skeleton sx={{ height: height }} animation='wave' variant='rectangular' />
          <Skeleton animation='wave' />
          <Skeleton width='60%' animation='wave' />
        </Card>
      </Grid>
    );
  };
  return renderImageSkeleton();
};

export default ImageSkeleton;
